/**
 * 处理时间
 */
const ResetStr = (strinfo) => {
  let hour = "";
  let minute = "";
  let second = "";
  strinfo = strinfo == null ? "" : strinfo.toString();
  if (strinfo.length <= 5) {
    hour = "0" + strinfo.substr(0, 1).toString();
    minute = strinfo.substr(1, 2).toString();
    second = strinfo.substr(3).toString();
  } else {
    hour = strinfo.substr(0, 2);
    minute = strinfo.substr(2, 2);
    second = strinfo.substr(4);
  }
  let resStrInfo = `${hour}:${minute}:${second}`;
  return resStrInfo;
};

const columns = [
  {
    title: "#",
    key: "id",
    width: 100,
  },
  {
    title: "IP地址段",
    render: (h, params) => {
      let fromIP = params.row.fromIP;
      let toIP = params.row.toIP;
      let result = "--";
      if (fromIP && toIP) {
        result = `${fromIP} - ${toIP}`;
      }
      return h("div", result);
    },
  },
  {
    title: "时间段",
    render: (h, params) => {
      let timeFrom = params.row.timeFrom;
      let timeTo = params.row.timeTo;
      let result = "";
      if (timeFrom == 0) {
        result = "--";
      } else {
        result = `${ResetStr(timeFrom)} - ${ResetStr(timeTo)}`;
      }
      return h("div", result);
    },
  },
  {
    title: "域名",
    key: "name",
  },
  {
    title: "域名匹配模式",
    width: 150,
    render(h, params) {
      let info = "";
      switch (params.row.matchMode) {
        case "prefix":
          info = "前缀";
          break;
        case "suffix":
          info = "后缀";
          break;
        case "equals":
          info = "完全";
          break;
        default:
          info = "包含";
          break;
      }
      return h("div", `${info}匹配`);
    },
  },
  {
    title: "IP分发模式",
    width: 150,
    render(h, params) {
      let info = "";
      switch (params.row.dispatchMode) {
        case "round-robin":
          info = "轮循";
          break;
        case "iphash":
          info = "IP Hash";
          break;
        default:
          info = "随机";
          break;
      }
      return h("div", info);
    },
  },
  {
    title: "启用",
    key: "dept_contcat",
    slot: "tableSwitch",
    width: 100,
    Switchs: true,
  },
  {
    title: "操作",
    slot: "iconfont",
    width: 100,
    iconClass: [
      { name: "ys-iconbianji", code: 1, status: 1, Pname: "" }, // 编辑
      {
        name: "ys-iconlajitongbeifen",
        code: -1,
        status: 1,
        Pname: "",
      }, // 删除
    ],
  },
];

export default columns;
